module.exports = __webpack_public_path__ + "static/media/SubscribeWithGoogle.ad484fc6.svg";